<template>
	<div class="container">
		<div class="statisticsBox">
			<ul>
				<li>
					<p class="jctj"><i class="el-icon-s-data" style="padding-right: 2%;"></i>就餐统计</p>
				</li>
				<li>
					<div class="tjsx">
						<p class="tjBtitle tjBsumz">总人数</p>
						<p class="tjBsum tjBsumz">{{OrderAllNum}}</p>
					</div>
				</li>
				<li>
					<div class="tjsx">
						<p class="tjBtitle tjBsumy">已销核人数</p>
						<p class="tjBsum tjBsumy">{{OrderWriteOffNum}}</p>
					</div>
				</li>
				<li>
					<div class="tjsx">
						<p class="tjBtitle tjBsumw">未销核人数</p>
						<p class="tjBsum tjBsumw">{{OrderNoWriteOffNum}}</p>
					</div>
					<!-- <el-popover placement="bottom" width="450" trigger="click">
						<el-table :data="gridData" max-height='400' v-loading="loading">
							<el-table-column width="110" property="username" label="账号"></el-table-column>
							<el-table-column width="100" property="realname" label="姓名"></el-table-column>
							<el-table-column width="120" property="depart" label="部门"></el-table-column>
							<el-table-column width="120" property="phone" label="电话"></el-table-column>
						</el-table>
						<el-button class="openXhx" slot="reference" @click="getNoWirteOffUser"></el-button>
					</el-popover> -->
					<el-popover placement="bottom" width="550" trigger="click">
						<!-- <el-table :data="gridData" max-height='400' v-loading="loading">
							<el-table-column width="150" property="username" label="账号"></el-table-column>
							<el-table-column width="100" property="realname" label="姓名"></el-table-column>
							<el-table-column width="160" property="depart" label="部门"></el-table-column>
							<el-table-column width="120" property="phone" label="电话"></el-table-column>
						</el-table> -->
						<div class="gridBox">
							<div v-for="item in gridData" class="gridItem" style="">
								<div style="display: flex;margin-top: 2px;">
									<div style="flex: 1;"><span style="font-weight: bold;">账号：</span>{{item.username}}
									</div>
									<div style="flex: 1;"><span style="font-weight: bold;">姓名：</span>{{item.realname}}
									</div>
									<div style="flex: 1;"><span style="font-weight: bold;">电话：</span>{{item.phone}}
									</div>
								</div>
								<div style="margin-top: 4px;"><span style="font-weight: bold;">部门：</span>{{item.depart}}
								</div>
								<div style="margin-top: 4px;margin-bottom: 4px;"><span
										style="font-weight: bold;">订餐详情：</span>{{item.orderGoodsText}}</div>
							</div>
						</div>

						<el-button class="openXhx" slot="reference" @click="getNoWirteOffUser"></el-button>
					</el-popover>
				</li>

			</ul>
		</div>
		<div class="headBox">
			<div class="header">
				<img src="../../assets/ml.png" class="mlLogo" alt="">
				<div class="headTit">
					<p>米力·文明食堂</p>
				</div>
			</div>
		</div>
		<div class="containerIner">
			<div class="leftBox" style="position: relative;height: 76vh;">
				<div class="hxGrBox" style="position: absolute;top:0%;z-index:0;">
					<div class="hxBox">
						<div class="hxInput">
							<el-input placeholder="" @blur="blurInput" :disabled="isDisabled" ref='hxInput'
								v-model="value">
								<template slot="prepend"><i class="el-icon-full-screen"></i><span
										style="font-size:16px">核销码</span></template>
							</el-input>
						</div>
					</div>
				</div>

				<div class="leftTopBox" style="position: absolute;top:0%;z-index:999;">
					<div style="width: 100%;height:20px;"></div>
					<div v-show="face==false">
						<div class="gdLiBox">
							<!-- <el-button type="primary" style="display: table;margin: 2% auto;" plain @click="face=true">
								刷脸核销</el-button> -->
							<div class="statisticsTit">
								<ul>
									<li>
										<p>菜品名称</p>
									</li>
									<li>
										<p>销核数量</p>
									</li>
									<li>
										<p>剩余数量</p>
									</li>
									<li>
										<p>未销核数量</p>
									</li>
									<li>
										<p>总数量</p>
									</li>
								</ul>
							</div>

							<vue-seamless-scroll :data="tableData" class="seamless-warp" ref="scroll"
								:class-option="defaultOption">
								<ul class="itemSe">
									<li class="seL" v-for="item in tableData">
										<p>
											<span v-if="item.numRemaining <= 10"
												style="color:#F56C6C;">{{item.foodId}}</span>
											<span v-else>{{item.foodId}}</span>
										</p>
										<p>{{item.numWriteOff}}</p>
										<p>
											<span v-if="item.numRemaining <= 10"
												style="color:#F56C6C;">{{item.numRemaining}}</span>
											<span v-else>{{item.numRemaining}}</span>
										</p>
										<p>{{item.numNoWriteOff}}</p>
										<p>{{item.numAll}}</p>
									</li>
								</ul>
							</vue-seamless-scroll>
						</div>
						<div style="display: flex;">
							<div style="margin-left:4%;margin-top: 7%;">
								<el-button type="primary" round style="width: 100%;" @click="stopScroll"><i
										:class="isPaused ? 'el-icon-unlock':'el-icon-lock'"></i></el-button>
								<!-- {{ isPaused ? '解锁' : '锁定' }} -->
							</div>
							<div style="width: 50%;margin-left:8%;margin-top: 7%;">
								<el-button type="primary" round style="width: 100%;" @click="face=true"><i
										class="el-icon-help el-icon--left"></i>刷脸取餐</el-button>
							</div>
						</div>
					</div>
					<div class="login-mid" @click="faceVef()" v-show="face==true">
						<div class="login-mid-top">
							<div class="shadow-top-left"></div>
							<div class="shadow-top-right"></div>
						</div>
						<div class="login-mid-mid">
							<div class="videoCamera-canvasCamera" @click="faceVef()">
								<video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
								<canvas style="display: none" id="canvasCamera" :width="videoWidth"
									:height="videoHeight"></canvas>
								<div v-if="faceImgState" class="face-special-effects-2"></div>
								<div v-else class="face-special-effects"></div>
							</div>
							<div class="face-btn">
								<button @click="faceVef()">{{faceImgState?'正在识别中...':'开始识别'}}</button>
							</div>

						</div>
						<!-- <div class="login-mid-bot">
							<div class="shadow-bot-left"></div>
							<div class="shadow-bot-right"></div>
						</div> -->
					</div>
					<div style="width:32%;margin: 10% 34% 0 34%; " v-if="face==true">
						<el-button class="smhx" type="primary" plain @click="face=false">查看核销数据</el-button>
					</div>
				</div>

			</div>
			<div class="rightBox" v-if="faceChoose==false">
				<div v-if="foodList == undefined ||foodList == null || foodList.length <= 0" style="margin-top: 8%;">
					<el-empty :image-size="400" :image="img" description="暂无核销内容"></el-empty>
				</div>
				<div v-loading="loading" element-loading-text="订单加载中" v-else>
					<div style="width: 100%; height: 10px;"></div>
					<div v-for="item in foodList">
						<div class="hxinfBox">
							<el-descriptions title="核销信息" direction="vertical" :column="5" border>
								<el-descriptions-item label="订单号">{{item.orderMainId}}</el-descriptions-item>
								<el-descriptions-item label="预定人">{{item.createBy}}</el-descriptions-item>
								<el-descriptions-item label="金额">{{item.money}}</el-descriptions-item>
								<el-descriptions-item label="核销状态">
									<el-tag size="small" v-if="item.status=='1'">{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="warning" v-if="item.status=='2'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="success" v-if="item.status=='3'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="danger" v-if="item.status=='4'">
										{{item.status | foodCategory}}
									</el-tag>
								</el-descriptions-item>

							</el-descriptions>
						</div>
						<div class='foodList'>
							<div class="yhxBox" v-if="item.status=='3'"></div>
							<el-table :data="item.goodsList" :row-style="{height:'70px'}"
								style="width: 100%; font-size: 25px; color:#333;font-weight: bold;">
								<el-table-column prop="footName" label="菜品" width="200">
								</el-table-column>
								<el-table-column prop="num" label="数量">
								</el-table-column>
								<el-table-column prop="price" label="单价">
								</el-table-column>
								<el-table-column prop="status" label="状态">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>

			</div>
			<div class="rightBox" v-else>
				<div class="foodCont" v-if="faceChooseA==false">
					<div v-for="item in foodList">
						<div class="hxinfBox">
							<el-descriptions class="margin-top" title="核销信息" :column="2" border>
								<template slot="extra">
									<el-button type="primary" @click="handleHx(item.id)">核销此单</el-button>
								</template>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-collection-tag"></i>
										订单号
									</template>
									{{item.orderMainId}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-tickets"></i>
										菜品名称
									</template>
									{{item.title}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-user"></i>
										预定人
									</template>
									{{item.createBy}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-coin"></i>
										金额
									</template>
									{{item.money}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-full-screen"></i>
										核销状态
									</template>
									<el-tag size="small" v-if="item.status=='1'">{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="warning" v-if="item.status=='2'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="success" v-if="item.status=='3'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="danger" v-if="item.status=='4'">
										{{item.status | foodCategory}}
									</el-tag>
								</el-descriptions-item>
							</el-descriptions>

						</div>
					</div>
				</div>
				<div class="foodCont" v-else>
					<div v-for="item in foodList">
						<div class="hxinfBox">
							<el-descriptions class="margin-top" title="核销信息" :column="2" border>
								
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-collection-tag"></i>
										订单号
									</template>
									{{item.orderMainId}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-tickets"></i>
										菜品名称
									</template>
									{{item.title}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-user"></i>
										预定人
									</template>
									{{item.createBy}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-coin"></i>
										金额
									</template>
									{{item.money}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										<i class="el-icon-full-screen"></i>
										核销状态
									</template>
									<el-tag size="small" v-if="item.status=='1'">{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="warning" v-if="item.status=='2'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="success" v-if="item.status=='3'">
										{{item.status | foodCategory}}
									</el-tag>
									<el-tag size="small" type="danger" v-if="item.status=='4'">
										{{item.status | foodCategory}}
									</el-tag>
								</el-descriptions-item>
							</el-descriptions>

						</div>
						<div class='foodList'>
							<div class="yhxBox" v-if="item.status=='3'"></div>
							<el-table :data="item.goodsList" :row-style="{height:'70px'}"
								style="width: 100%; font-size: 25px; color:#333;font-weight: bold;">
								<el-table-column prop="footName" label="菜品" width="200">
								</el-table-column>
								<el-table-column prop="num" label="数量">
								</el-table-column>
								<el-table-column prop="price" label="单价">
								</el-table-column>
								<el-table-column prop="status" label="状态">
								</el-table-column>
							</el-table>
						</div>
					</div>
					
					<!-- {{item.orderMainId}}
					{{item.money}}
					 -->
				</div>
			</div>
		</div>
		<div class="bottomLine">
			<p style="color:#409EFF;font-size: 20px;font-weight: bold;">本软件由海盐米力信息科技有限公司提供技术支持</p>
		</div>
	</div>

</template>
<script>
	import $camera from '../../camera/index.js'
	import vueSeamlessScroll from 'vue-seamless-scroll'
	export default {
		components: {
			vueSeamlessScroll
		},
		data() {
			return {
				hxsuc: false,
				isDisabled: false,
				img: require('@/assets/none.png'),
				hxms: '',
				OrderAllNum: '',
				OrderWriteOffNum: '',
				OrderNoWriteOffNum: '',
				focus: true,
				face: false,
				value: null,
				videoWidth: 400,
				videoHeight: 275,
				msg: '',
				faceImgState: false,
				faceOption: {},
				foodList: [],
				loading: true,
				tableData: [],
				hoverFlag: true,
				isPaused: false,
				gridData: [],
				audio: new Audio(),
				successUrl: require("../../assets/suc.mp3"),
				orgCode: '',
				code: '',
				faceChoose: false,
				faceChooseA:false,
				faceChooseList:[],
				faceCont:[]
			};
		},
		// 监听属性 类似于data概念
		computed: {
			defaultOption() {
				return {
					step: 0.5, // 数值越大速度滚动越快
					limitMoveNum: 13, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: this.hoverFlag, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}


		},

		watch: {
			value(curVal, oldVal) {
				// 实现input连续输入，只发一次请求
				clearTimeout(this.timeout)
				this.timeout = setTimeout(() => {
					this.handleChangeName(curVal)
				}, 200)
			}
		},
		filters: {
			foodCategory: function(val) {
				if (val == '1') {
					return '核销成功'
				}
				if (val == '2') {
					return '未完全核销'
				}
				if (val == '3') {
					return '完全核销'
				}
				if (val == '4') {
					return '已退单'
				}
			}
		},
		mounted() {
			this.faceOption = $camera.getCamera({
				videoWidth: 200,
				videoHeight: 200,
				thisCancas: null,
				thisContext: null,
				thisVideo: null,
				canvasId: 'canvasCamera',
				videoId: 'videoCamera'
			});
			this.onHxInputRef();
			this.refreshData = setInterval(() => {
				this.getTable();
			}, 20000);
			this.refreshData2 = setInterval(() => {
				this.checkStatus()
			}, 180000);
			// this.getright_table();
			//this.getCompetence();
		},
		beforeDestroy() {
			clearInterval(this.refreshData);
			this.refreshData = null;
			clearInterval(this.refreshData2);
			this.refreshData2 = null;
		},
		created() {
			let query = this.$route.query
			this.hxms = query.value;
			this.orgCode = query.orgCode;
			this.code = query.code
			this.getTable();
			this.checkStatus()
			// console.log('qu', this.hxms)
		},

		methods: {
			stopScroll() {
				if (!this.isPaused) {
					this.$refs.scroll._cancle();
					this.hoverFlag = false;
					this.isPaused = !this.isPaused
				} else {
					this.$refs.scroll._startMove();
					this.hoverFlag = true;
					this.isPaused = !this.isPaused
				}

			},
			getTable() {
				this.$http.get("/mlpt/mlptOrder/queryOrderStatisticalQuantity?category=" + this.hxms + "&orgCode=" + this
					.orgCode).then(res => {
					this.tableData = res.data.result.StatisticalList;
					this.OrderAllNum = res.data.result.OrderAllNum;
					this.OrderWriteOffNum = res.data.result.OrderWriteOffNum;
					this.OrderNoWriteOffNum = res.data.result.OrderNoWriteOffNum;
					// console.log('ll', res)
				}, onerror => {
					this.refreshData = setInterval(() => {
						this.getTable();
					}, 20000);
				})
			},
			getNoWirteOffUser() {
				this.$http.get("/mlpt/mlptOrder/queryOrderNoWirteOffUser").then(res => {
					this.loading = false;
					this.gridData = res.data.result;
					// console.log('gridData', this.gridData)
				}, onerror => {

				})
			},
			onHxInputRef() {
				this.$nextTick(() => {
					this.$refs.hxInput.focus()
				})
			},
			blurInput() {
				this.onHxInputRef();
			},
			handleHx(value){
				console.log('id',value)
				this.faceChooseA = true;
				// console.log('zt',this.faceChooseA)
				if (value === '') {
					return false;
				} else {
					this.loading = false;
					this.isDisabled = true;
					this.$http.post("/mlpt/mlptOrder/writeOff", {
						id: value,
						category: this.hxms,
						hxCode: this.code
					}).then(res => {
						this.value = "";
						if (res.data.success == true) {
							this.audio.autoplay = true;
							this.audio.src = this.successUrl;
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.foodList = res.data.result;
							// console.log('jg',this.faceCont)
							this.foodList.forEach(function(item, index) {
								let ids = item.goodsList;
								ids.forEach(function(items, index) {
									if (items.status == '1') {
										items.status = '未核销'
									}
									if (items.status == '3') {
										items.status = '完全核销'
									}
								});
							});
							// 核销成功后刷新统计数据
							this.getTable();
							
						} else {
							this.isDisabled = false;
							this.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
						setTimeout(() => {
							this.value = "";
							this.isDisabled = false;
							this.getTable();
							this.blurInput();
						}, 3000)
						// console.log(foodN)
					}, onerror => {
						this.loading = false;
						this.isDisabled = false;
						this.$message({
							message: "网络异常，请稍后重试",
							type: 'error'
						});
					})
				}
			},
			handleChangeName(value) {
				this.faceChooseA=false;
				this.faceChoose=false;
				// console.log('value',value)
				if (value === '') {
					return false;
				} else {
					this.loading = false;
					this.isDisabled = true;
					this.$http.post("/mlpt/mlptOrder/writeOff", {
						id: value,
						category: this.hxms,
						hxCode: this.code
					}).then(res => {
						this.value = "";
						if (res.data.success == true) {
							this.audio.autoplay = true;
							this.audio.src = this.successUrl;
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.foodList = res.data.result;
							console.log('ddd',this.foodList)
							this.foodList.forEach(function(item, index) {
								let ids = item.goodsList;
								ids.forEach(function(items, index) {
									if (items.status == '1') {
										items.status = '未核销'
									}
									if (items.status == '3') {
										items.status = '完全核销'
									}
								});
							});
							// 核销成功后刷新统计数据
							this.getTable();
						} else {
							this.isDisabled = false;
							this.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
						setTimeout(() => {
							this.value = "";
							this.isDisabled = false;
							// this.foodList = [];
							this.getTable();
							this.blurInput();
						}, 3000)
						// console.log(foodN)
					}, onerror => {
						this.loading = false;
						this.isDisabled = false;
						this.$message({
							message: "网络异常，请稍后重试",
							type: 'error'
						});
					})
				}
				// console.log('sr', value)
			},
			// tableRowClassName({
			// 	row,
			// 	rowIndex
			// }) {
			// 	// if (rowIndex === 1) {
			// 	// 	return 'warning-row';
			// 	// } else if (rowIndex === 3) {
			// 	// 	return 'success-row';
			// 	// }
			// 	if (row.status == '未核销') {
			// 		return 'warning-row';
			// 	} else if (row.status == '完全核销') {
			// 		return 'success-row';
			// 	}
			// 	return '';
			// },

			// 调用后台接口
			faceVef() {
				this.faceChooseA = false;
				// 开始绘制图片
				let imageBase = $camera.draw(this.faceOption)
				if (this.faceImgState) {
					return
				}
				this.faceImgState = true
				if (imageBase === '' || imageBase === null || imageBase === undefined) {
					this.$message.error("人脸数据为空")
				} else {
					this.$http.post("/mlpt/mlptOrder/faceWriteOff", {
						images: imageBase,
						category: this.hxms,
						hxCode: this.code
					}).then(res => {
						this.loading = false;
						this.faceImgState = false
						if (res.data.success == true) {
							if (res.data.result && res.data.result.length > 1) {
								// console.log('>1', res.data)
								this.faceChoose = true;
								this.foodList = res.data.result;
								this.foodList.forEach(function(item, index) {
									let ids = item.goodsList;
									ids.forEach(function(items, index) {
										if (items.status == '1') {
											items.status = '未核销'
										}
										if (items.status == '3') {
											items.status = '完全核销'
										}
									});
								});
							} else {
								
								// let value = res.data.result[0].id;
								this.handleChangeName(res.data.result[0].id);
								// console.log('1', value)
								// this.audio.autoplay = true;
								// this.audio.src = this.successUrl;
								// this.$message({
								// 	message: res.data.message,
								// 	type: 'success'
								// });
								// this.foodList = res.data.result;
								// this.foodList.forEach(function(item, index) {
								// 	let ids = item.goodsList;
								// 	ids.forEach(function(items, index) {
								// 		if (items.status == '1') {
								// 			items.status = '未核销'
								// 		}
								// 		if (items.status == '3') {
								// 			items.status = '完全核销'
								// 		}
								// 	});
								// });
								// setTimeout(() => {
								// 	this.getTable();
								// }, 3000)
							}

						} else {
							this.$message({
								message: res.data.message,
								type: 'warning'
							});
							// console.log('aa', res.data.message)
						}

					}, onerror => {
						this.faceImgState = false
					})
				}
			},
			goAssist() {
				this.$router.push({
					name: 'assist'
				})
			},
			checkStatus() {
				this.$http.get("/system/sysDevice/pushHeartbeat?code=" + this.code).then(res => {
					// console.log('pushHeartbeat', res)
				}, onerror => {
					this.faceImgState = false
				})
			}

		},
	};
</script>
<style>
	@import "./index.css";

	.statisticsBox {
		width: 48%;
		height: 90px;
		position: absolute;
		top: 3%;
		right: 8.4%;
		background-color: #fff;
		border-radius: 15px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		overflow: hidden;
	}

	.statisticsBox li {
		float: left;
		width: 25%;
		height: 90px;
		text-align: center;
	}

	.jctj {
		line-height: 90px;
		font-size: 25px;
		background-color: #409EFF;
		color: #fff;
		font-weight: bold;

	}

	.tjBtitle {
		font-size: 25px;
		color: #66b1ff;
		font-weight: bold;
	}

	.tjBsum {
		font-size: 25px;
		font-weight: bold;
	}

	.tjBsumy {
		color: #19be6b;
	}

	.tjBsumz {
		color: #409EFF !important;
	}

	.tjBsumw {
		color: #ff9900 !important;
	}

	.tjsx {
		margin-top: 10px;
		height: 70px;
		border-right: .5px solid #eee;
	}

	.tjsx :last-child {
		border-right: 0 !important;
	}

	.statisticsTit {
		width: 100%;
		height: 50px;
		color: #409EFF;
		margin: 0 auto;
		overflow: hidden;
		background-color: #f2f6fc;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;
	}

	.gdLiBox {
		width: 95%;
		margin: 0 auto;
	}

	.statisticsTit ul {
		overflow: hidden;
	}

	.statisticsTit li {
		width: 20%;
		height: 50px;
		line-height: 50px;
		font-size: 18px;
		float: left;
		text-align: center;
		font-weight: bold;
	}

	.itemSe li p {
		display: block;
		float: left;
		width: 20%;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		text-align: center;
		white-space: nowrap;
		text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
	}

	.itemSe .seL:nth-child(even) {
		background-color: rgb(242 246 252);
	}

	.seL p {
		font-size: 20px;
		font-weight: bold;
	}

	.itemSe li {
		width: 100%;
		height: 40px;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;
	}

	.seamless-warp {
		margin-top: 2%;
		height: 56vh;
		overflow: hidden;
	}

	.foodBox {
		width: 100%;
	}
	.foodCont{
		width: 100%;
		height: 500px;
		overflow-y: auto; 
	}
	.hxinfBox {
		width: 95%;
		margin: 1% auto;
	}

	.foodList {
		width: 95%;
		margin: 2% auto;
		height: 50vh;
		overflow-y: auto;
	}

	.yhxBox {
		width: 200px;
		height: 200px;
		position: absolute;
		right: 14%;
		bottom: 22%;
		background: url("../../assets/yhx.png")no-repeat;
		background-size: cover;
		z-index: 999;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.bottomLine {
		width: 80%;
		margin: 1% auto;
		/* margin-bottom: 10%; */
	}

	.bottomLine p {
		font-size: 16px;
		color: #909399;
		text-align: center;
	}

	.hxGrBox {
		width: 98%;
		/* width: 40%; */
		height: 9vh;
		border-radius: 15px;
		background-color: #fff;
		margin: 0 auto;
		margin-bottom: 2%;
		-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	.leftTopBox {
		width: 98%;
		/* width: 40%; */
		margin: 0 auto;
		height: 76vh;
		border-radius: 15px;
		background-color: #fff;
		-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	.leftBottomBox {
		width: 100%;
		height: 290px;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 200px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.adv {
		width: 100%;
		height: 290px;
	}

	.adv img {
		width: 100%;
		height: 290px;
	}

	.smhx {
		display: block !important;
		width: 82%;
		margin: 0 auto !important;
	}

	.openXhx {
		width: 24%;
		height: 70px;
		position: absolute;
		top: 10%;
		right: 1%;
		background-color: transparent !important;
		border: 0 !important;
	}

	.login-mid {
		min-height: 380px !important;
		max-height: 60% !important;
	}

	.gridBox {
		margin-top: 6px;
		min-height: 20vh;
		max-height: 50vh;
		overflow-y: auto;
	}

	.gridItem {
		border-bottom: 1px solid #ebebeb;
		padding: 4px 0;
	}

	.gridBox .gridItem:last-child {
		border-bottom: none !important;
	}
</style>